<template>
  <div class="examples">
    <div class="banner">
      <img src="../assets/images/examples/banner.png" alt="" />
      <div class="text">
        <div class="title">打造互联网数据与应用生态体系</div>
        <div class="subTitle">
          资产管理平台的设计理念将资产管理保障体系作为产品设计依据，以资产的生命周期作为管理主线，以资产的实物属性、价值属性为管理核心，来对其使用全程进行可续合理的管控，以提高资产的流转效率，支撑医院、学校、企业等基础运行环境的有序运转。
        </div>
      </div>
    </div>

    <!-- 典型案例 -->
    <div class="examList">
      <div class="examTitle">
        <span class="line1"></span>
        典型案例
        <span class="line2"></span>
      </div>
      <div class="examImgs">

            <div class="box" v-for="(item,index) in article_list1" v-if="index==0" :style="{ width: boxWidth1 + 'rem' }"  @click="gotoDisplay(item.id)" @mouseenter="enterImg(1)" @mouseleave="leaveImg">
              <transition name="fade" appear>
                <div class="modal" v-show="modalShow1">
                  <div class="modalTitle">{{item.title}}</div>
                  <div class="modalSub">{{item.desc}}</div>
                </div>
              </transition>
              <img :src="item.thumb" alt="" />
            </div>

          <div class="box" v-for="(item,index) in article_list1" v-if="index==1" :style="{ width: boxWidth2 + 'rem' }"  @click="gotoDisplay(item.id)" @mouseenter="enterImg(2)" @mouseleave="leaveImg">
              <transition name="fade" appear>
                  <div class="modal" v-show="modalShow2">
                      <div class="modalTitle">{{item.title}}</div>
                      <div class="modalSub">{{item.desc}}</div>
                  </div>
              </transition>
              <img :src="item.thumb" alt="" />
          </div>

          <div class="box" v-for="(item,index) in article_list1" v-if="index==2" :style="{ width: boxWidth3 + 'rem' }"  @click="gotoDisplay(item.id)" @mouseenter="enterImg(3)" @mouseleave="leaveImg">
              <transition name="fade" appear>
                  <div class="modal" v-show="modalShow3">
                      <div class="modalTitle">{{item.title}}</div>
                      <div class="modalSub">{{item.desc}}</div>
                  </div>
              </transition>
              <img :src="item.thumb" alt="" />
          </div>

          <div class="box" v-for="(item,index) in article_list1" v-if="index==3" :style="{ width: boxWidth4 + 'rem' }"  @click="gotoDisplay(item.id)" @mouseenter="enterImg(4)" @mouseleave="leaveImg">
              <transition name="fade" appear>
                  <div class="modal" v-show="modalShow4">
                      <div class="modalTitle">{{item.title}}</div>
                      <div class="modalSub">{{item.desc}}</div>
                  </div>
              </transition>
              <img :src="item.thumb" alt="" />
          </div>

      </div>
    </div>

    <!-- 合作客户 -->
    <div class="hospitals">
      <div class="hosTitle">
        <span class="line1"></span>
        合作客户
        <span class="line2"></span>
      </div>
      <div class="hosItems">
        <div class="item" v-for="(item,index) in article_list">
          <img :src="item.thumb" alt="" />
          <div class="name">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "examples",
  data() {
    return {
      boxWidth1: 47,
      boxWidth2: 26.5,
      boxWidth3: 26.5,
      boxWidth4: 26.5,
      modalShow1: false,
      modalShow2: false,
      modalShow3: false,
      modalShow4: false,

      article_list:[],
      article_list1:[]
    };
  },
    created() {
        this.getarticlelist();
        this.getarticlelist1();
    },
  methods: {
      getarticlelist() {
          let self = this;
          var url = "index/article_list?cate_id=8";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.article_list = res.data.data.list;
          })
      },
      getarticlelist1() {
          let self = this;
          var url = "index/article_list?cate_id=9";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.article_list1 = res.data.data.list;
          })
      },
    enterImg(val) {
      if (val == 1) {
        this.boxWidth1 = 47;
        this.boxWidth2 = 26.5;
        this.boxWidth3 = 26.5;
        this.boxWidth4 = 26.5;
        this.modalShow1 = true;
      } else if (val == 2) {
        this.boxWidth1 = 26.5;
        this.boxWidth2 = 47;
        this.boxWidth3 = 26.5;
        this.boxWidth4 = 26.5;
        this.modalShow2 = true;
      } else if (val == 3) {
        this.boxWidth1 = 26.5;
        this.boxWidth2 = 26.5;
        this.boxWidth3 = 47;
        this.boxWidth4 = 26.5;
        this.modalShow3 = true;
      } else if (val == 4) {
        this.boxWidth1 = 26.5;
        this.boxWidth2 = 26.5;
        this.boxWidth3 = 26.5;
        this.boxWidth4 = 47;
        this.modalShow4 = true;
      }
    },
    leaveImg() {
      this.modalShow1 = false;
      this.modalShow2 = false;
      this.modalShow3 = false;
      this.modalShow4 = false;
    },
    gotoDisplay(val) {
      this.$router.push(`/display/detail/${val}`);
    },
  },


};
</script>

<style lang="scss" scoped>
.examples {
  width: 192rem;

  .banner {
    width: 100%;
    position: relative;

    img {
      width: 100%;
    }

    .text {
      position: absolute;
      right: 20rem;
      top: 35rem;
      width: 80rem;

      .title {
        font-size: 4.6rem;
        color: #0077ff;
        margin-bottom: 5rem;
      }

      .subTitle {
        font-size: 2.8rem;
        color: #93969b;
      }
    }
  }

  .examList {
    padding: 5rem 0 10rem 0;
    background: url("../assets/images/examples/bgc.jpg") no-repeat;

    .examTitle {
      width: 128rem;
      margin: 0 auto;
      font-size: 3.6rem;
      padding-bottom: 5rem;
      position: relative;
      text-align: center;

      span {
        display: inline-block;
        position: absolute;
        width: 5rem;
        height: 0.2rem;
        background-color: #35a0dc;
      }

      .line1 {
        left: 48rem;
        top: 2.5rem;
      }

      .line2 {
        right: 48rem;
        top: 2.5rem;
      }
    }

    .examImgs {
      width: 128rem;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      overflow: hidden;

      .box {
        overflow: hidden;
        transition: all 0.5s ease-in-out;
        position: relative;
        img{
          width: 470px;
          height: 450px;
        }
        .modal {
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 9;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          padding-top: 20rem;


          div {
            color: #fff;
            font-size: 1.4rem;
            font-weight: 300;
            text-align: center;
          }

          .modalTitle {
            margin-bottom: 1rem;
          }
        }
      }
    }
  }

  .hospitals {
    width: 128rem;
    margin: 0 auto;
    padding: 5rem 0;

    .hosTitle {
      font-size: 3.6rem;
      padding-bottom: 5rem;
      position: relative;
      text-align: center;

      span {
        display: inline-block;
        position: absolute;
        width: 5rem;
        height: 0.2rem;
        background-color: #35a0dc;
      }

      .line1 {
        left: 48rem;
        top: 2.5rem;
      }

      .line2 {
        right: 48rem;
        top: 2.5rem;
      }
    }

    .hosItems {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;

      .item {
        img {
          width: 30rem;
          //cursor:pointer
        }

        .name {
          width: 30rem;
          text-align: center;
          padding: 1.2rem 0 3rem 0;
          font-size: 1.8rem;
          font-weight: 400;
        }

      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.6s ease-in-out;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
@media screen and (max-width: 750px) {
  .examples{
    .banner{
      .text{
        right: 15rem;
        width: 112rem;
        top:1rem;
      }
    }
    .examList{
      display: none;
      height: 150rem;
      .examTitle{
        font-size: 7.6rem;
        .line1{
          display: none;
        }
        .line2{
          display: none;
        }
      }
      .examImgs{
        height: 130rem;
      }
    }
    .hospitals{
        width: 95% !important;
        margin: 0 auto;
      .hosTitle{
        font-size: 7.6rem;
        .line1{
            display: none;
          }
          .line2{
            display: none;
          }
      }

        .hosItems {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;


            .item {
                width: 46%;
                img {
                    width: 100%;
                    //cursor:pointer
                }

                .name {
                    width: 100%;
                    text-align: center;
                    padding: 1.2rem 0 3rem 0;
                    font-size: 7rem !important;
                    font-weight: 400;
                }

            }
        }

    }
  }
}
</style>
